import cn from 'classnames';

import styles from './Spinner.module.scss';

export enum SpinnerType {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  DANGER = 'danger'
}

type SpinnerProps = {
  type?: SpinnerType;
  center?: boolean;
  message?: string;
  className?: string;
};

const Spinner: React.FC<SpinnerProps> = ({
  message,
  type,
  center,
  className
}) => (
  <div
    data-testid="spinner"
    className={cn(
      styles.container,
      {
        [styles.center]: center
      },
      className
    )}
  >
    <div
      className={cn(styles.loader, {
        [styles.primary]: type === SpinnerType.PRIMARY,
        [styles.danger]: type === SpinnerType.DANGER
      })}
    >
      Loading...
    </div>
    {!!message && <div className={styles.message}>{message}</div>}
  </div>
);

export default Spinner;
